import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export default function RoundsGuidelines() {
  return (
    <article className="pb-rounds-guidelines">
      <Link className="pb-rounds-back" to="/board/rounds"><ArrowLeft size={13} aria-hidden="true" />Back to Rounds</Link>
      <header>
        <ShieldCheck size={22} aria-hidden="true" />
        <p className="pb-board-eyebrow">Professional room</p>
        <h1>Rounds community guidelines</h1>
        <p>Rounds is a professional room for registered clinicians.</p>
      </header>
      <ol>
        <li><strong>No patient-identifying information, ever.</strong> This includes anonymised cases: no names, dates, ages over 89, suburbs, employers, or rare combinations.</li>
        <li><strong>Anonymised cases are for clinical reasoning, not advice about a specific patient’s management.</strong> Decisions stay with the treating clinician.</li>
        <li><strong>No dosing instructions for a specific case.</strong> General guidance with citations is fine.</li>
        <li><strong>No promotion of services, products or practices.</strong></li>
        <li><strong>Disagree with ideas, not people.</strong></li>
        <li><strong>Reports are reviewed within 24 hours.</strong> Hidden content is reviewed by a human; repeated breaches lead to removal.</li>
        <li><strong>Nothing here constitutes a referral, a consultation, or a record.</strong></li>
      </ol>
    </article>
  );
}
